<template lang="html">
  <content-block :controls="controls" :fresh="block.edit" @edit="editBlock()" @input="saveChanges()" @remove="deleteBlock()">
    <div v-if="edit">
      <label>{{ $t('content_block_text_label') }}</label>
      <ckeditor v-model="block.data.text" ></ckeditor>
    </div>
    <div v-else="edit" class="content_block__text" v-html="block.data.text"></div>
  </content-block>
</template>

<script>
  import CKEditor from '~/components/global/CKEditor'
  import ContentBlock from './ContentBlock'

export default {
  components: {
    ContentBlock,
    CKEditor
  },
  name: "ContentBlockText",
  props: {
    block: {
      type: Object,
    },
    controls: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      edit: false
    }
  },
  mounted () {
    if (this.controls) {
      this.edit = this.block.edit || false;
    }
  },
  methods: {
    editBlock () {
      this.edit = true;
    },
    deleteBlock () {
      this.$emit('remove')
    },
    saveChanges() {
      this.edit = false;
      this.$emit('input', this.block)
    }
  }
}
</script>
